<template>
  <div>
    <template v-if="fileList && fileList.length > 0">
      <div :class="type=='img'?'img-one':'list-one'" v-for="(item,index) in fileList" :key="index">
        <el-image v-if="type=='img'" :preview-src-list="fileList"  v-show="item" :src="item" alt=""></el-image>
        <!-- <img v-if="type=='img'" :src="item" alt="" :preivew="12"> -->
        <div v-else>
          <el-link  type="primary" :href="item" target="_blank">{{ addBaseUrl(item) }}</el-link>
          <!-- <a :href="item">{{addBaseUrl(item)}}</a> -->
        </div>
        <span v-if="!disabled" class="el-icon-close" @click="deleteImg(index)"></span>
      </div>
    </template>
    <template v-else>
      <div style="color: #999">暂无数据</div>
    </template>
    <el-upload
      v-if="!disabled"
      :class="type=='img'?'img-uploader':''"
      :show-file-list="false"
      action="#"
      :before-upload="handleBeforeUpload"
      :on-change="handleChange"
      :auto-upload="false"
      :accept="type=='img'?'image/*':'.doc,.docx,.xls,.xlsx,.pdf'">
        <i v-if="type=='img'" class="el-icon-plus img-uploader-icon"></i>
        <el-button v-else size="small" type="primary">点击上传</el-button>
    </el-upload>
  </div>
</template>

<script>
import { uploadImg } from '@/api/common'
import { baseUrl } from '@/config/env'
export default {
  props: {
    type: {
      type: String,
      default: 'file'
    },
    dataKey: {
      type: String
    },
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      imageUrl: '',
      fileList: this.data || []
    }
  },
  watch: {
    dataList: {
      handler (newVal, oldVal) {
        this.fileList = newVal
      },
      deep: true
    },
    fileList: {
      handler (newVal, oldVal) {
        let info = {
          key: this.dataKey,
          value: newVal
        }
        this.$emit('changeData', info)
      },
      deep: true
    }
  },
  methods: {
    addBaseUrl (url) {
      return url.includes('http') ? url : baseUrl + url
    },
    handleBeforeUpload (file, fileList) {
      console.log(file, fileList)
    },
    handleChange (file) {
      // console.log(file)
      this.submitUpload(file)
    },
    deleteImg (index) {
      this.fileList.splice(index, 1)
    },
    async submitUpload (file) {
      let formDataOne = new FormData()
      formDataOne.append('file', file.raw)
      formDataOne.append('folder', 'emergency')
      let res = await uploadImg(formDataOne)
      if (res.code === '000000') {
        this.fileList.push(res.data.url)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.img-uploader{
  display: inline-block;
  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-upload:hover {
    border-color: #409EFF;
  }
}
  .img-one{
    display: inline-block;
    width: 100px;
    height: 100px;
    position: relative;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    margin-right: 5px;
    margin-bottom: 5px;
    vertical-align: top;
    img{
      width: 100%;
      height: 100%;
    }
    .el-icon-close{
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 20px;
      display: none;
      cursor: pointer;
    }
    &:hover{
      border-color: #409EFF;
      .el-icon-close{
        display: block;
        color: #409EFF;
      }

    }
  }
  .list-one{
    position: relative;
    padding: 0 10px;
    padding-right: 20px;
    .el-icon-close{
      position: absolute;
      top: 10px;
      right: 5px;
      font-size: 20px;
      display: none;
      cursor: pointer;
    }
    &:hover{
      background-color: #f5f5f5;
      .el-icon-close{
        display: block;
      }
    }
  }
  .img-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
</style>
